/**
 * Collection URLs are /collections/<handle>. The handle is stored on the collection (generated
 * from its name, unique per store, unchanged by a rename), so links never depend on the title.
 * The backend resolves old URLs (edited handles, the pre-handle "%20" name URL) and answers
 * with a redirect to the canonical handle.
 */

/** Reserved: the all-products listing. A collection named "All" has a handle like `all-1`. */
export const ALL_COLLECTIONS_HANDLE = "all";

/**
 * Link for a collection (`{ handle, title }`). A collection without a handle (not yet
 * backfilled) links by its trimmed title, which the backend still resolves and redirects.
 */
export const collectionPath = (collection) => {
  const handle = collection?.handle;
  if (handle) return `/collections/${encodeURIComponent(handle)}`;

  const title = String(collection?.title || collection?.name || "").trim();
  return title
    ? `/collections/${encodeURIComponent(title)}`
    : `/collections/${ALL_COLLECTIONS_HANDLE}`;
};

/** The listed collection a /collections/<handle> URL names, if it is in the list (exact handle). */
export const findCollectionByHandle = (collections, handle) => {
  if (!handle) return null;
  return (collections || []).find((collection) => collection?.handle === handle) || null;
};
